<div class="dcue-page">
  <header class="dcue-hero">
    <div class="dcue-hero-badge" aria-hidden="true">
      <mat-icon>restaurant</mat-icon>
    </div>
    <div class="dcue-hero-copy">
      <h1>Forplejningsevents</h1>
      <p>
        Dit personlige overblik over events med forplejning, bestillinger og godkendelser.
      </p>
    </div>
  </header>

  @if (linkValidationPending && linkUuid) {
    <mat-card class="dcue-card dcue-state-card">
      <mat-card-content>
        <div class="dcue-state">
          <mat-icon class="spin">hourglass_top</mat-icon>
          <span>Tjekker forplejningslink…</span>
        </div>
      </mat-card-content>
    </mat-card>
  }

  @if (linkErrorMessage) {
    <mat-card class="dcue-card dcue-error-card">
      <mat-card-content>
        <div class="dcue-state dcue-state--error">
          <mat-icon>error_outline</mat-icon>
          <span>{{ linkErrorMessage }}</span>
        </div>
      </mat-card-content>
    </mat-card>
  }

  @if (showEventTables) {
    <section class="dcue-summary-section">
      <mat-card class="dcue-card dcue-summary-card">
        <div class="dcue-card-top">
          <div class="dcue-card-heading">
            <h2>Forplejningsoversigt</h2>
            <p>Se bestillinger og præferencer for kommende events i den valgte periode.</p>
          </div>
          <div class="dcue-filter-row">
            @for (days of dayOptions; track days) {
              <button
                type="button"
                class="dcue-chip"
                [class.active]="cateringSummaryDays === days"
                (click)="setCateringSummaryDays(days)">
                {{ dayOptionLabel(days) }}
              </button>
            }
          </div>
        </div>

        <div class="dcue-widget-host">
          <app-duna-catering-summary-widget
            [data]="cateringSummaryData"
            [isLoading]="cateringSummaryLoading"
            [fillHeight]="true"
            [showPdfDownload]="true"
            [allowEventNavigation]="false"
            pdfTitle="Forplejningsoversigt"
            (openPreferences)="openCateringPreferences($event)">
          </app-duna-catering-summary-widget>
        </div>
      </mat-card>
    </section>

    <section class="dcue-tables-section">
      <mat-card class="dcue-card dcue-table-card">
        <div class="dcue-table-header">
          <div class="dcue-table-heading">
            <mat-icon>pending_actions</mat-icon>
            <div>
              <h2>Afventer / kræver gen-godkendelse</h2>
              <p>Events der mangler godkendelse eller er ændret siden sidst.</p>
            </div>
          </div>
        </div>
        <mat-card-content>
          <app-dynamic-table #pendingTable [dynamicInput]="{ dataSource: { type: 'text', value: 'duna_catering_unique_pending' } }">
          </app-dynamic-table>
        </mat-card-content>
      </mat-card>

      <mat-card class="dcue-card dcue-table-card">
        <div class="dcue-table-header">
          <div class="dcue-table-heading">
            <mat-icon>verified</mat-icon>
            <div>
              <h2>Godkendt</h2>
              <p>Events hvor forplejningen er godkendt og matcher nuværende deltagerantal.</p>
            </div>
          </div>
        </div>
        <mat-card-content>
          <app-dynamic-table #approvedTable [dynamicInput]="{ dataSource: { type: 'text', value: 'duna_catering_unique_approved' } }">
          </app-dynamic-table>
        </mat-card-content>
      </mat-card>
    </section>
  }
</div>
